import React from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateTransactionStatusReduxParams } from '~types/feat/approval';

import { TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateTransactionStatusModal.module.scss';

const ConfirmUpdateTransactionStatusModal = () => {
    const isOpen = useAppSelector(state => state.gold.modals.confirmUpdateTransactionStatusModalIsOpen);
    const tempUpdateTransactionState = useAppSelector(state => state.gold.tempUpdateTransactionState);
    const isLoading = useAppSelector(state => state.gold.loadings.updateTransactionStatus);
    const error = useAppSelector(state => state.gold.errors.updateTransactionStatus);

    const getStatus = () => {
        switch (tempUpdateTransactionState.status) {
            case (TransactionStatusEnum.Cancelled): return 'Cancel Transaction';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.goldSetConfirmUpdateTransactionStatusModalIsOpen(open));
    const updateTransactionStatus = (data: TUpdateTransactionStatusReduxParams) => dispatch(combinedActions.goldUpdateTransactionStatusAttempt(data));

    const handleSubmitClick = () => {
        updateTransactionStatus(tempUpdateTransactionState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Cancel Transaction' ? Styles['confirm-cancel'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.goldResetUpdateTransactionStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()}?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateTransactionStatusModal;
